import ApiService from '@/services/api.service';
import getters from '@/store/global';
import store from '@/store';

const state = {
    photos: {},
    count: '',
    next: '',
    prev: '',
    errors: {},
    puzzles: {},
    details: {},
    isAlbum: false,
    albumIsUpdated: false
};

getters['fetchPhotos'] = function(state) { return state.photos;}
getters['fetchPhotoDetails'] = function(state) { return state.details;}
getters['fetchPhotosCount'] = function(state) { return state.count;}
getters['fetchPhotosNext'] = function(state) { return state.next;}
getters['fetchPhotosPrev'] = function(state) { return state.prev;}
getters['fetchPuzzles'] = function(state) { return state.puzzles;}
getters['fetchPhotoAlbumIsUpdated'] = function(state) { return state.albumIsUpdated;}

const actions = {
    getAll(context, payload) {
        return ApiService
            .get('profile/' + payload + '/photos/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_PHOTOS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_PHOTOS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getAlbum(context, payload) {
        return ApiService
            .get('albums/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_PHOTOS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_PHOTOS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getDetails(context, payload) {
        return ApiService
            .get('photos/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_DETAILS', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_DETAILS', {});
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_PHOTOS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getPrev(context) {
        return ApiService
            .get(context.state.prev)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_PHOTOS_PREV', response.data.results);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    create(context, payload) {
        return ApiService
            .post('photos/create/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_NEW_PHOTOS', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    delete(context, payload) {
        //console.log(payload);
        return ApiService
            .put('photos/remove/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_PHOTOS', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    like(context, payload) {
        return ApiService
            .get('photos/' + payload + '/like/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTES', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    dislike(context, payload) {
        return ApiService
            .get('photos/' + payload + '/dislike/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTES', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    update(context, payload) {
        return ApiService
            .patch('photos/update/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('UPDATE_PHOTOS', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    updateDescription(context, payload) {
        return ApiService
            .patch('photos/update/', payload)
            .then(() => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    addPuzzles(context, payload) {
        context.commit('ADD_PUZZLES', payload);
    },
    clearPuzzles(context) {
        context.commit('CLEAR_PUZZLES');
    },
    setBought(context, payload) {
        context.commit('SET_BOUGHT', payload);
    },
    setIsAlbum(context, payload) {
        context.commit('SET_IS_ALBUM', payload);
    }
};

const mutations = {
    SET_PHOTOS(state, photos) {
        state.photos = {};
        for (let i in photos) {
            state.photos[i] = photos[i];
        }
        state.errors = {};
    },
    ADD_PHOTOS(state, photos) {
        let total = state.count;
        let currentCount = Object.keys(state.photos).length;
        if (total == currentCount) {
            state.next = '';
            state.prev = '';
            return;
        }
        let firstEmpty;
        for (let i = 0; i < total; i++) {
            if (!state.photos[i]) {
                firstEmpty = parseInt(i);
                break;
            }
        }
        for (let j in photos) {
            state.photos[firstEmpty + parseInt(j)] = photos[j];
        }
        state.errors = {};
    },
    ADD_PHOTOS_PREV(state, photos) {
        let total = state.count;
        let currentCount = Object.keys(state.photos).length;
        if (total == currentCount) {
            state.next = '';
            state.prev = '';
            return;
        }
        let lastEmpty;
        for (let i = total; i > 0; i--) {
            if (!state.photos[i - 1]) {
                lastEmpty = i;
                break;
            }
        }
        let prevCount = photos.length;
        for (let j = 0; j < prevCount; j++) {
            state.photos[lastEmpty - prevCount + j] = photos[j];
        }
        state.errors = {};
    },
    ADD_NEW_PHOTOS(state, photos) {
        state.count += photos.length;
        let temp = Object.assign({}, state.photos);
        state.photos = {};
        for (let i in photos) {
            state.photos[i] = photos[i];
        }
        for (let j in temp) {
            state.photos[photos.length + parseInt(j)] = temp[j];
        }
        state.errors = {};
    },
    REMOVE_PHOTOS(state, photos) {
        let temp = Object.assign({}, state.photos);
        let count = 0;
        state.photos = {};
        for (let i in temp) {
            if (photos.indexOf(temp[i].id) == -1) {
                state.photos[count] = temp[i];
                count++;
            }
        }
        state.count -= photos.length;
        state.errors = {};
    },
    UPDATE_PHOTOS(state, updated) {
        if (!state.isAlbum) {
            if (updated[0].album) {
                state.albumIsUpdated = true;
                setTimeout(() => {
                    state.albumIsUpdated = false;
                }, 300);
            }
            return;
        }
        let removed = [];
        for (let i in updated) {
            if (updated[i].album) {
                removed.push(updated[i].id);
            }
        }
        if (removed.length == 0) {
            return;
        }
        state.count -= removed.length;
        let temp = Object.assign({}, state.photos);
        let count = 0;
        state.photos = {};
        for (let i in temp) {
            if (removed.indexOf(temp[i].id) == -1) {
                state.photos[count] = temp[i];
                count++;
            }
        }
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_PREV(state, data) {
        if (data.num_pages == 1) {
            state.prev = '';
            return;
        }
        if (data.page > 1) {
            state.prev =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page - 1);
        } else {
            state.prev =
            data.url +
            '?' +
            data.page_param +
            '=' +
            data.num_pages;
        }
        state.errors = {};
    },
    SET_VOTES(state, votes) {
        state.details.liked = votes.liked;
        state.details.disliked = votes.disliked;
        state.details.likes = votes.likes;
        state.details.dislikes = votes.dislikes;
        state.errors = {};
        store.dispatch('home/setVoted', [votes, 'photos']);
    },
    SET_DETAILS(state, details) {
        state.details = details;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    ADD_PUZZLES(state, payload) {
        state.puzzles[payload.id] = payload.puzzle;
    },
    CLEAR_PUZZLES(state) {
        state.puzzles = {};
    },
    SET_BOUGHT(state, id) {
        for (let i in state.photos) {
            if (state.photos[i].id == id) {
                state.photos[i].bought = true;
            }
        }
    },
    SET_IS_ALBUM(state, isAlbum) {
        state.isAlbum = isAlbum;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
